import { asyncScheduler, type MonoTypeOperatorFunction } from "rxjs";
import { throttleTime } from "rxjs/operators";

/**
 * Pass the first value straight through, then at most one value per `ms`,
 * always ending on the latest.
 *
 * EventStore timelines emit once per inserted event, synchronously. A relay
 * page or an IndexedDB cache hit inserts hundreds to thousands of events in
 * one task, so a derivation that rebuilds a whole list (issue/PR lists, CI
 * workflow grouping) per emission does O(n²) work in a single long frame.
 * Put this between the store streams and any such derivation.
 */
export function coalesceBursts<T>(ms = 100): MonoTypeOperatorFunction<T> {
  return throttleTime(ms, asyncScheduler, { leading: true, trailing: true });
}
